import { defineStore } from 'pinia';
import api from '@/api/enviosAPI';
import type { Envio } from '@/types/envioTypes';

export const useEnviosStore = defineStore('envios', {
  state: () => ({
    envios: [] as Envio[],
    searchTerm: '',
    detailedEnvios: new Set<number>(),
    loading: false,
    error: null as string | null,
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0
    }
  }),

  getters: {
    sortedEnvios: (state) => {
      return state.envios.slice().sort(
        (a: Envio, b: Envio) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
    },
    
    isDetailed: (state) => (id: number) => state.detailedEnvios.has(id)
  },

  actions: {
    async fetchEnvios() {
      this.loading = true;
      this.error = null;

      try {
        const response = await api.getEnvios(
          this.pagination.page,
          this.pagination.pageSize,
          this.searchTerm
        );

        this.envios = response.results;
        this.pagination.total = response.count;
      } catch (error) {
        this.error = error instanceof Error ? error.message: 'Error desconocido';
        console.error('Error fetching envios:', error)
      } finally {
        this.loading = false;
      }
    },

    async createEnvio(data: any) {
      const response = await api.createEnvio(data);
      await this.fetchEnvios();
      return response;
    },

    // Nueva acción para actualizar un envio
    async updateEnvio(id: number, data: any) {
      try {
        const response = await api.updateEnvio(id, data);
        // Actualizar la lista de envios
        await this.fetchEnvios();
        return response;
      } catch (error) {
        console.error('Error updating envio:', error);
        throw error;
      }
    },

    setSearchTerm(term: string) {
      this.searchTerm = term;
      // Resetear a primera página al buscar
      this.pagination.page = 1;
      this.fetchEnvios()
    },

    toggleDetail(id: number) {
      if (this.detailedEnvios.has(id)) {
        this.detailedEnvios.delete(id);
      } else {
        this.detailedEnvios.add(id);
      }
    },
    
    /* async fetchOperators() {
      const response = await axios.get('/api/operadores/');
      this.operators = response.data;
    } */
  }
});
